const projectsCommentedOn = [
    { repo_full_name: "B2B", count: 1 },
    { repo_full_name: "B2C", count: 13 },
    { repo_full_name: "Static", count: 2 },
];

const commentTimestamps = [
    {
        datetime: "2021-11-30T15:26:51.000Z",
        clusters: {
            "12am - 6am": { count: 1 },
            "6am - 12pm": { count: 1 },
            "12pm - 6pm": { count: 1 },
            "6pm - 12pm": { count: 1 },
        },
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        clusters: {
            "12am - 6am": { count: 1 },
            "6am - 12pm": { count: 1 },
            "12pm - 6pm": { count: 1 },
            "6pm - 12pm": { count: 1 },
        },
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        clusters: {
            "12am - 6am": { count: 1 },
            "6am - 12pm": { count: 1 },
            "12pm - 6pm": { count: 1 },
            "6pm - 12pm": { count: 1 },
        },
    },
    {
        datetime: "2021-12-02T15:26:51.000Z",
        clusters: {
            "12am - 6am": { count: 1 },
            "6am - 12pm": { count: 1 },
            "12pm - 6pm": { count: 1 },
            "6pm - 12pm": { count: 1 },
        },
    },
    {
        datetime: "2021-12-03T15:26:51.000Z",
        clusters: {
            "12am - 6am": { count: 1 },
            "6am - 12pm": { count: 1 },
            "12pm - 6pm": { count: 1 },
            "6pm - 12pm": { count: 1 },
        },
    },
    {
        datetime: "2021-12-04T15:26:51.000Z",
        clusters: {
            "12am - 6am": { count: 1 },
            "6am - 12pm": { count: 1 },
            "12pm - 6pm": { count: 1 },
            "6pm - 12pm": { count: 1 },
        },
    },
    {
        datetime: "2021-12-05T15:26:51.000Z",
        clusters: {
            "12am - 6am": { count: 1 },
            "6am - 12pm": { count: 1 },
            "12pm - 6pm": { count: 1 },
            "6pm - 12pm": { count: 1 },
        },
    },
];

const reviewStats = {
    commentsCount: 4,
    averageCommentsPerMr: 7,
    commentedMrsCount: 11,
    approvalsCount: 4,
    reviewPickup: 11,
    reviewPickupsCount: 11,
    linesReviewedCount: 54534,
    baseline: {
        commentsCount: 9,
        averageCommentsPerMr: 5,
        commentedMrsCount: 11,
        approvalsCount: 1,
        reviewPickup: 11,
        reviewPickupsCount: 11,
        linesReviewedCount: 33212,
    },
};

const getReviews = () => {
    return {
        projectsCommentedOn,
        commentTimestamps,
        reviewStats,
    };
};

export default getReviews;
